export interface ITestimonial {
  name: string
  local?: string
  text: string
}

export const userTestimonials: ITestimonial[] = [
  {
    "name": "Juliano Moreira",
    "local": "Rio de Janeiro",
    "text": "Essa plataforma foi um achado. Já fiz alguns cursos e pretendo fazer outros. Excelente iniciativa!"
  },
  {
    "name": "Carla Martins",
    "local": "Minas Gerais",
    "text": "Muito obrigada pela oportunidade +IFMG. A qualidade dos cursos de vocês é incomparável, já indiquei para vários colegas de faculdade."
  },
  {
    "name": "José Henrique",
    "local": "Rio Grande do Norte",
    "text": "Perdi o emprego recentemente e estava buscando me capacitar para ampliar minhas chances no mercado de trabalho. A plataforma está me ajudando muito!"
  },
  {
    "name": "Miriam Gonlçaves",
    "local": "Paraná",
    "text": "Estou extremamente satisfeita. O material didático é incrível, assim que eu puder volto para fazer outro curso. Obrigada!"
  },
  {
    "name": "Roberto de Almeida",
    "local": "Tocantins",
    "text": "Gostei muito. Confesso que sempre tive preconceito com EaD, mas esses cursos aqui me fizeram mudar de ideia. Valeu +IFMG."
  },
  {
    "name": "Lucas Rabelo",
    "local": "Mato Grosso do Sul",
    "text": "Pretendia fazer apenas um curso para contar como atividades complementares na faculdade, mas achei tão bom que farei mais! Top!"
  },
  {
    "name": "Maria Cristina",
    "local": "Minas Gerais",
    "text": "Muito obrigada pela oportunidade. Já tenho certa idade e estava precisando melhorar meu currículo para conseguir um emprego melhor. "
  },
  {
    "name": "Julia Marcelina",
    "local": "Goiás",
    "text": "Aqui em casa todos fizemos cursos do +IFMG. É mesmo muito bom, parabéns a todos da equipe."
  },
  {
    "name": "Milena Rodrigues",
    "local": "São Paulo",
    "text": "Gente eu adorei! Vi que tem uns cursos mais avançados, mas comecei por uns iniciais e vou subindo aos poucos. Muitíssima obrigada!!!"
  },
  {
    "name": "Augusto Pena",
    "local": "Paraíba",
    "text": "Tenho alguns anos de experiência na minha profissão e tenho que reconhecer que o material didático é excelente. Realmente feito por profissionais gabaritados. Congratulações."
  }
];